import gql from 'graphql-tag';

import serviceActionMetadata from '../fragment/serviceActionMetadata';
import serviceActions from '../fragment/serviceActions';
import serviceCategories from '../fragment/serviceCategories';
import serviceInfo from '../fragment/serviceInfo';
import serviceMetadata from '../fragment/serviceMetadata';

/* eslint-disable graphql/no-deprecated-fields */
// FIXME: Get rid of deprecated `Query.service` field. Being tracked here:
// https://zapierorg.atlassian.net/browse/FLX-1771
export default gql`
  ${serviceActionMetadata}
  ${serviceActions}
  ${serviceCategories}
  ${serviceInfo}
  ${serviceMetadata}

  query FullServiceQuery($id: String!) {
    service(id: $id) {
      ...serviceActionMetadata
      ...serviceActions
      ...serviceCategories
      ...serviceInfo
      ...serviceMetadata
    }
  }
`;
/* eslint-enable graphql/no-deprecated-fields */
